<template>
  <b-modal
    ref="certificate-privacy-modal"
    id="certificate-privacy-modal"
    size="lg"
    hide-footer
    centered
    @cancel="cancelModal"
    @hidden="resetModal"
  >
    <template #modal-header="{ cancel }">
      <div class="d-flex justify-content-end w-100">
        <b-icon icon="x" variant="primary" scale="2" class="close-icon" @click="cancel()" />
      </div>
    </template>
    <h4 class="text-primary text-left">{{ trans("courses.certificate.sharing.label") }}</h4>
    <b-img
      src="/images/certificate/illustration_privacy.svg"
      fluid
      class="my-4 img-fluid mx-auto d-block"
    />
    <div class="row justify-content-md-center">
      <h6 class="col-12 col-md-8 text-center">
        {{ trans("courses.certificate.sharing.modal.subtitle") }}
      </h6>
    </div>
    <div class="row justify-content-md-center">
      <p
        class="col-12 col-md-8 text-center"
        v-html="trans('courses.certificate.sharing.modal.text')"
      ></p>
    </div>
    <div class="d-flex justify-content-end mt-4">
      <b-button variant="light" class="mr-2" @click="cancelModal">
        {{ trans("courses.certificate.sharing.modal.cancel") }}
      </b-button>
      <b-button variant="secondary" @click="submitModal">
        {{ trans("courses.certificate.sharing.modal.enable") }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "CertificatePrivacyModal",
  methods: {
    showModal() {
      this.$bvModal.show("certificate-privacy-modal");
    },
    submitModal() {
      localStorage.setItem("shareCertificate", "1");
      this.$emit("submitModal");
    },
    cancelModal() {
      this.$bvModal.hide("certificate-privacy-modal");
    },
    resetModal() {
      localStorage.removeItem("shareCertificate");
      this.$emit("cancelModal");
    },
  },
  mounted() {
    if (localStorage.getItem("shareCertificate") === null) {
      this.showModal();
    }
  },
};
</script>

<style lang="scss">
.modal-header {
  padding-bottom: 0;
  .close-icon {
    cursor: pointer;
  }
}
.modal-body {
  padding-top: 0;
}
</style>
